import { cookieHelper, CookieKeyEnum } from '@/app/cookies';
import { calculateAvailableToResendIn } from '../../lib/utils/calculateAvailableToResendIn';
import type { ResendEmailCodeSchema } from '../types/resendEmailCodeSchema';

export const initialState: ResendEmailCodeSchema = {
    availableToResendIn: calculateAvailableToResendIn(cookieHelper.get(CookieKeyEnum.NEXT_CODE_RESEND_DATE)),
    loading: false,
};
